import { render } from "./TrashPage.vue?vue&type=template&id=ed5499d8&ts=true"
import script from "./TrashPage.vue?vue&type=script&lang=ts"
export * from "./TrashPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__